import React from 'react';
import { array, bool, func } from 'prop-types';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';

import CampusSitesTableRowMenu from './CampusSitesTableRowMenu';

import classes from './CampusSitesTable.module.css';

const CampusSitesTable = ({
    campusSites,
    isFullArchitectAllowed,
    onToggleDeleteCampusSiteModal,
    onSort,
    order,
    orderBy,
    ...props
}) => {
    const isSortedByName = orderBy === 'name';
    const sortDirection = isSortedByName ? order : false;

    return (
        <Table className={classes.table}>
            <TableHead>
                <TableRow>
                    <TableCell
                        className={classes.headerCell}
                        sortDirection={sortDirection}
                        onClick={onSort('name')}
                    >
                        <Tooltip
                            title={
                                <span className={classes.tooltip}>
                                    Sort
                                </span>
                            }
                            placement="top-start"
                        >
                            <TableSortLabel
                                active={isSortedByName}
                                direction={order}
                            >
                                Name
                            </TableSortLabel>
                        </Tooltip>
                    </TableCell>
                    <TableCell className={classes.headerCell}>
                        Building Type
                    </TableCell>
                    <TableCell padding="none" />
                </TableRow>
            </TableHead>
            <TableBody>
                {campusSites.map(site =>
                    <TableRow key={site.id}>
                        <TableCell className={`${classes.dataCell} ${classes.ellipseCell}`}>
                            <Tooltip
                                title={
                                    <span className={classes.tooltip}>
                                        {site.name}
                                    </span>
                                }
                                placement="top-start"
                            >
                                <span>{site.name}</span>
                            </Tooltip>
                        </TableCell>
                        <TableCell className={`${classes.dataCell} ${classes.ellipseCell}`}>
                            <Tooltip
                                title={
                                    <span className={classes.tooltip}>
                                        {site.buildingType.name}
                                    </span>
                                }
                                placement="top-start"
                            >
                                <span>{site.buildingType.name}</span>
                            </Tooltip>
                        </TableCell>
                        <TableCell
                            className={classes.rowMenuCell}
                            padding="none"
                        >
                            <CampusSitesTableRowMenu
                                campusSite={site}
                                hidden={!isFullArchitectAllowed}
                                onToggleDeleteCampusSiteModal={onToggleDeleteCampusSiteModal}
                            />
                        </TableCell>
                    </TableRow>
                )}
            </TableBody>
        </Table>
    );
};

CampusSitesTable.defaultProps = {
    isFullArchitectAllowed:        true,
    onSort:                        () => { },
    onToggleDeleteCampusSiteModal: () => { }
};

CampusSitesTable.propTypes = {
    campusSites:                   array.isRequired,
    isFullArchitectAllowed:        bool,
    onSort:                        func,
    onToggleDeleteCampusSiteModal: func
};

export default CampusSitesTable;
